<template>
  <div class="home-links page-component">
    <div class="container">
      <div class="home-links__container">
        <a v-for="(field, fieldName) in fields"
            :key="fieldName" 
            :href="'/#/home#' + fieldName" 
            class="icon-link"
        >
          <i class="material-icons">{{ getIcon(fieldName) }}</i>
          <span>{{ $prismic.richTextAsPlain(field) }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../EventBus'

export default {
  name: 'HomeLinks',
  data () {
    return {
      fields: {
        sights: null,
        trips: null,
        events: null,
        area: null,
        culture: null,
        restaurants: null,
        hotels: null,
        shopping: null
      }
    }
  },
  methods: {
    async getContent (language) {
      let document = await this.$prismic.client.getSingle('homelinks', {lang: language})
      if (document) {
        this.fields.sights = document.data.sights
        this.fields.trips = document.data.trips
        this.fields.events = document.data.events
        this.fields.area = document.data.area
        this.fields.culture = document.data.culture
        this.fields.restaurants = document.data.restaurants
        this.fields.hotels = document.data.hotels
        this.fields.shopping = document.data.shopping
      } else {
        this.$router.push({ name: 'not-found' })
      }
    },
    getIcon (fieldName) {
      let iconMap = {
        'sights': 'local_see',
        'trips': 'directions_boat',
        'events': 'book',
        'area': 'call_split',
        'culture': 'flare',
        'restaurants': 'local_dining',
        'hotels': 'hotel',
        'shopping': 'shopping_cart',
        'arrival': 'airport_shuttle',
        'good2know': 'info_outline'
      }
      return iconMap[fieldName]
    }
  },
  async created () {
    await this.getContent(window.KriensTourismus.language)

    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  },
}
</script>

<style scoped>

</style>
